<template>
  <el-checkbox :label="item.id" class="professional-checkbox">
    <div class="professional-info d-flex gap-2 align-items-center w-full">
      <el-avatar :size="48" :shape="'circle'" icon="el-icon-user-solid" :src="item.imageUrl" />

      <div class="d-flex align-items-center gap-2 w-full">
        <div class="d-flex flex-col">
          <div class="professional-name">{{ item.name }} {{ item.lastName }}</div>
          <div class="professional-location d-flex align-items-center gap-1">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M3.625 5C3.625 4.37011 3.87522 3.76602 4.32062 3.32062C4.76602 2.87522 5.37011 2.625 6 2.625C6.62989 2.625 7.23398 2.87522 7.67938 3.32062C8.12478 3.76602 8.375 4.37011 8.375 5C8.375 5.62989 8.12478 6.23398 7.67938 6.67938C7.23398 7.12478 6.62989 7.375 6 7.375C5.37011 7.375 4.76602 7.12478 4.32062 6.67938C3.87522 6.23398 3.625 5.62989 3.625 5ZM6 3.375C5.56902 3.375 5.1557 3.5462 4.85095 3.85095C4.54621 4.1557 4.375 4.56902 4.375 5C4.375 5.43098 4.54621 5.8443 4.85095 6.14905C5.1557 6.45379 5.56902 6.625 6 6.625C6.43098 6.625 6.8443 6.45379 7.14905 6.14905C7.45379 5.8443 7.625 5.43098 7.625 5C7.625 4.56902 7.45379 4.1557 7.14905 3.85095C6.8443 3.5462 6.43098 3.375 6 3.375Z"
                fill="#009F98" />
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M1.76199 4.4285C1.84768 3.39199 2.31989 2.42556 3.08494 1.721C3.84998 1.01644 4.85194 0.625228 5.89199 0.625H6.10799C7.14804 0.625228 8.15 1.01644 8.91504 1.721C9.68008 2.42556 10.1523 3.39199 10.238 4.4285C10.3333 5.58317 9.97657 6.72973 9.24299 7.6265L6.84649 10.557C6.74393 10.6824 6.61478 10.7835 6.46839 10.8529C6.32199 10.9223 6.162 10.9583 5.99999 10.9583C5.83798 10.9583 5.67799 10.9223 5.53159 10.8529C5.3852 10.7835 5.25605 10.6824 5.15349 10.557L2.75699 7.6265C2.02341 6.72973 1.66667 5.58317 1.76199 4.4285ZM5.89199 1.375C5.0403 1.37536 4.21985 1.69582 3.59339 2.27282C2.96693 2.84982 2.58023 3.64121 2.50999 4.49C2.43063 5.45095 2.72749 6.40517 3.33799 7.1515L5.73449 10.0825C5.7667 10.1219 5.80728 10.1537 5.85329 10.1755C5.89929 10.1973 5.94957 10.2087 6.00049 10.2087C6.05141 10.2087 6.10169 10.1973 6.14769 10.1755C6.19369 10.1537 6.23427 10.1219 6.26649 10.0825L8.66299 7.1515C9.27313 6.40502 9.56963 5.45081 9.48999 4.49C9.41974 3.64112 9.03297 2.84967 8.4064 2.27265C7.77984 1.69564 6.95927 1.37523 6.10749 1.375H5.89199Z"
                fill="#009F98" />
            </svg>
            <span v-if="type =='preferred'">{{ item?.address?.suburb ? item?.address?.suburb : 'N/A' }}, {{ item?.address?.state ? item?.address?.state : 'N/A' }}</span>
            <span v-else>{{ item?.address?.fullAddress ? item?.address?.fullAddress : 'N/A' }}</span>
          </div>
          <div class="professional-location d-flex align-items-center gap-1" v-if="item?.type">
            <svg width="12" height="12"
                viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.9999 17C15.6623 17 18.8649 18.5751 20.607 20.9247L18.765 21.796C17.3473 20.1157 14.8473 19 11.9999 19C9.15248 19 6.65252 20.1157 5.23479 21.796L3.39355 20.9238C5.13576 18.5747 8.33796 17 11.9999 17ZM11.9999 2C14.7613 2 16.9999 4.23858 16.9999 7V10C16.9999 12.7614 14.7613 15 11.9999 15C9.23847 15 6.9999 12.7614 6.9999 10V7C6.9999 4.23858 9.23847 2 11.9999 2Z"
                  fill="rgb(var(--locumate-primary-color))"></path>
              </svg>
            <span>{{ item?.type ? item?.type : 'N/A' }}</span>
          </div>
        </div>

        <span v-if="showInfoIcon" class="locumate_icons locumate_icon-info" @click.prevent="handleShowDetails"></span>

        <div class="professional-type ml-auto" v-html="icon">
        </div>
      </div>
    </div>
  </el-checkbox>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    showInfoIcon: {
      type: Boolean,
      default: false
    },
    icon: String,
    type: String,
  },
  emits: ['show-details'],
  methods: {
    handleShowDetails() {
      // Create a new object to break any potential reference
      const details = {
        ...this.item,
        id: this.item.id,
        name: this.item.name,
        email: this.item.email,
        rate: this.item.rate || '$0',
        notes: Array.isArray(this.item.notes) ? [...this.item.notes] : []
      };
      
      console.log('Emitting details for:', details.id); // Debug log
      this.$emit('show-details', details);
    }
  }
};
</script>